<template>
  <div>
    <v-row class="py-0">
      <v-col cols="3">
        <v-card max-width="300">
          <v-list shaped>
            <v-subheader class="font-italic text-subtitle-1">Pending Tools</v-subheader>
            <v-divider></v-divider>
            <v-list-item-group color="dw_green">
              <v-list-item v-if="pendingTools.length === 0" disabled>
                <v-list-item-content>
                  <v-list-item-title>No tools to review</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else
                v-for="(tool, i) in pendingTools"
                :key="i"
                @click="reviewTool(tool)"
                two-line
                dense>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-regular">
                    {{ tool.pending_state.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption grey--text">
                    {{ pendingState(tool.action) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col v-if="selectedTool" cols="8">
        <v-form ref="reviewToolForm" v-model="formValid" @submit.prevent>
          <v-card flat v-if="selectedTool.action === 'UPD' && originalTool" class="mb-3" outlined>
            <v-card-title class="py-2 text-h6 font-weight-light">Original Tool</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-2 px-8">
              <p class="mb-0">Name</p>
              <p class="white--text">{{ originalTool.name }}</p>
              <p class="mb-0">Source URL</p>
              <p class="white--text">{{ originalTool.url || '--' }}</p>
              <p class="mb-0">Description</p>
              <p class="white--text">{{ originalTool.description || '--' }}</p>
            </v-card-text>
          </v-card>
          <v-card flat outlined>
            <v-card-title class="py-2 text-h6 font-weight-light">
              Suggested Tool
              <v-spacer></v-spacer>
              <span class="text-body-2">{{ selectedTool.submitted_by }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="px-4 py-0">
              <moderate-text-field
                ref="modNameField"
                :existing="selectedTool.pending_state.name"
                label="Tool Name *"
                @saveChanges="(e) => editTool('name', e)" />
              <moderate-text-field
                ref="modUrlField"
                :existing="selectedTool.pending_state.url"
                label="Souce URL *"
                :isUrl="true"
                @saveChanges="(e) => editTool('url', e)" />
              <moderate-text-area
                ref="modDescField"
                :existing="selectedTool.pending_state.description"
                label="Description"
                :isRequired="false"
                @saveChanges="(e) => editTool('description', e)" />
            </v-card-text>
          </v-card>
          <v-row class="mt-12" no-gutters>
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              :disabled="isBeingEdited"
              @click="approveTool"
              color="primary"
              small
              text>
              Approve
              <v-icon small color="primary" class="ml-2" v-text="mdiCheckOutline" />
            </v-btn>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiCheckOutline, mdiPencilOutline, mdiCloseOutline } from '@mdi/js';
import { mapActions, mapGetters } from 'vuex';
import moderateTextField from '@/components/forms/reviewModerations/moderateTextField.vue';
import moderateTextArea from '@/components/forms/reviewModerations/moderateTextArea.vue';
import utils from '@/utils';

export default {
  name: 'reviewTools',
  components: {
    moderateTextField,
    moderateTextArea
  },
  data: () => ({
    mdiCheckOutline,
    mdiPencilOutline,
    mdiCloseOutline,
    selectedTool: undefined,
    formValid: false,
    originalTool: undefined,
    isBeingEdited: false
  }),
  computed: {
    ...mapGetters([
      'pendingTools'
    ])
  },
  methods: {
    pendingState: utils.pendingState,
    ...mapActions([
      'moderateTool',
      'fetchPending',
      'fetchOriginalByID',
      'fetchFilterOptions'
    ]),
    checkActive() {
      this.isBeingEdited = (this.$refs.modNameField && this.$refs.modNameField.editField)
        || (this.$refs.modUrlField && this.$refs.modUrlField.editField)
        || (this.$refs.modDescField && this.$refs.modDescField.editField);
    },
    async approveTool() {
      try {
        await this.moderateTool({
          ...this.selectedTool,
          approved: true
        });
        this.selectedTool = undefined;
        this.fetchPending();
        this.fetchFilterOptions();
      } catch (err) {
        console.error(err);
      }
    },
    async reviewTool(tool) {
      this.selectedTool = tool;
      if (this.selectedTool.action === 'UPD') {
        this.originalTool = await this.fetchOriginalByID(['tool', this.selectedTool.target]);
      }
    },
    async editTool(field, newVal) {
      const changed = {
        ...this.selectedTool,
        pending_state: {
          ...this.selectedTool.pending_state,
          [field]: newVal
        }
      };
      try {
        await this.moderateTool(changed);
        this.fetchPending();
        this.selectedTool = changed;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
